import {EventDefinition, LookupTableDefinition, PropertyDefinition} from 'apps/lexicon/src/models';
import {Metric} from 'app_api/projects/metrics/types';
import {BehaviorEntity as Behavior} from 'app_api/projects/behaviors/types';

export {DEFAULT_DATA_GROUP_ID} from 'common/widgets/data-group-selector-tabs/constants';

/* eslint-disable @typescript-eslint/naming-convention */
export const enum BulkActions {
  hide = `bulkHide`,
  unhide = `bulkUnhide`,
  dismissWarnings = `bulkDismissWarnings`,
  dismiss = `bulkDismiss`,
  drop = `bulkDrop`,
  undrop = `bulkUndrop`,
  mapToLookupTable = `bulkMapToLookupTable`,
  unMapFromLookupTable = `bulkunMapFromLookupTable`,
  upgradeToMapToLookupTable = `upgradeToMapToLookupTable`,
  merge = `bulkMerge`,
  markSensitive = `bulkMarkSensitive`,
  unmarkSensitive = `bulkUnmarkSensitive`,
  unmerge = `bulkUnmerge`,
  tag = `bulkTag`,
  delete = `bulkDelete`,
  download = `bulkDownload`,
  moreActionsOverflow = `dropdownAction`,
  editOwnership = `editOwnership`,
  verify = `bulkVerify`,
  unverify = `bulkUnverify`,
}

export type LexiconDefinition = EventDefinition | PropertyDefinition | LookupTableDefinition | Metric | Behavior;

export enum DataVolumeAnomalyStatus {
  Open = `open`,
  Dismissed = `dismissed`,
}

export type DataVolumeAnomaly = {
  id: number;
  event?: number; // event ID
  event_name?: string;
  property?: number; // property ID
  property_name?: string;
  timestamp: number | null;
  actual_count: number;
  predicted_upper: number;
  predicted_lower: number;
  percent_variance: string;
  status?: DataVolumeAnomalyStatus;
};

// The View enum lives in the nav registry so bundles outside the lexicon app
// can use it without importing this file's model types; re-exported here for
// the app's own modules, which have historically imported it from types.
export {View} from 'apps/lexicon/src/registry';

export enum Status {
  Loading = `loading`,
  Success = `success`,
  Error = `error`,
}

export const LexiconEntitySpecialCharEscapeMap: Record<string, string> = {
  '\n': `$mp-nl`,
  '\t': `$mp-tab`,
  '\r': `$mp-cr`,
};
